import {useMemo} from 'react';

/**
 * Custom hook to normalize segments data
 * @param {Array} segments - Raw segments array
 * @param {Array} segmentsWithMetadata - Segments with full metadata
 * @param {string} docId - Document ID
 * @returns {Array} Normalized segments array
 */
export function useDisplaySegments({segments, segmentsWithMetadata, docId}) {
    return useMemo(() => {
        if (segmentsWithMetadata && segmentsWithMetadata.length > 0) {
            return segmentsWithMetadata;
        }

        if (!segments || segments.length === 0 || !docId) {
            return [];
        }

        return segments.map((content, index) => ({
            content: typeof content === 'string' ? content : (content?.content || ''),
            index: index,
            segmentId: null,
            _docId: docId,
            _index: index
        }));
    }, [segments, segmentsWithMetadata, docId]);
}
